import { InjectionToken } from '@angular/core';

import { SdkMessageHandler } from './../../../api';

/* Copyright IBM Corp. 2018 */
const LOGGER = 'SdkMessages';

// injection token
export const SDK_MESSAGE_HANDLER = new InjectionToken<SdkMessageHandler>('SdkMessageHandler');

